<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

<div *ngIf="loading" class="p-6 text-center text-gray-500">
  Loading temperature stability data...
</div>


<div *ngIf="!loading && tableData.length > 0" class="p-6">

 
  <div class="flex justify-center mb-6">
    <div class="relative flex bg-gray-100 rounded-full p-1 w-80">

   
      <div
        class="absolute top-1 bottom-1 w-1/2 bg-white rounded-full shadow transition-all duration-300"
        [ngClass]="{
          'left-1': activeTab === 'summary',
          'left-1/2': activeTab === 'table'
        }">
      </div>


      <button
        (click)="setTab('summary')"
        class="relative z-10 w-1/2 py-2 text-sm font-medium transition"
        [ngClass]="{
          'text-blue-600': activeTab === 'summary',
          'text-gray-600': activeTab !== 'summary'
        }">
        Summary
      </button>

  
      <button
        (click)="setTab('table')"
        class="relative z-10 w-1/2 py-2 text-sm font-medium transition"
        [ngClass]="{
          'text-blue-600': activeTab === 'table',
          'text-gray-600': activeTab !== 'table'
        }">
        Detailed Table
      </button>

    </div>
  </div>

  <!-- ================= SUMMARY TAB ================= -->
  <div *ngIf="activeTab === 'summary'">

    <!-- Calculation Method -->
    <div *ngIf="calculationMethod"
         class="mb-6 p-4 bg-gray-50 rounded-xl border">

      <div class="text-sm font-semibold text-gray-700 mb-2">
        Calculation Method
      </div>

      <div class="text-sm text-gray-600">
        {{ calculationMethod.description }}
      </div>
    </div>

    <!-- Interpretation Guide -->
    <div *ngIf="interpretation"
         class="mb-6 p-4 bg-blue-50 rounded-xl border border-blue-100">

      <div class="text-sm font-semibold text-blue-700 mb-3">
        Interpretation Guide
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-700">

        <div class="p-2 bg-white rounded-lg shadow-sm">
          <strong>100%:</strong> {{ interpretation['100%'] }}
        </div>

        <div class="p-2 bg-white rounded-lg shadow-sm">
          <strong>80–99%:</strong> {{ interpretation['80-99%'] }}
        </div>

        <div class="p-2 bg-white rounded-lg shadow-sm">
          <strong>50–79%:</strong> {{ interpretation['50-79%'] }}
        </div>

        <div class="p-2 bg-white rounded-lg shadow-sm">
          <strong>Below 50%:</strong> {{ interpretation['below_50%'] }}
        </div>

      </div>
    </div>

    <!-- Warehouse Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">

      <div *ngFor="let warehouse of tableData"
           class="p-5 bg-white rounded-2xl shadow-md border hover:shadow-lg transition">

        <div class="text-lg font-semibold text-gray-800 mb-4">
          {{ warehouse.warehouse_name }}
        </div>

        <!-- Stability Percentage -->
        <div class="flex items-center justify-between mb-4">

          <div class="text-sm text-gray-500">
            Temperature Stability
          </div>

          <div class="text-xl font-bold text-blue-600">
            {{ warehouse.temperature_stability }}%
          </div>

        </div>

        <!-- Progress Bar -->
        <div class="w-full bg-gray-200 rounded-full h-2 mb-4">
          <div
            class="h-2 rounded-full bg-blue-500 transition-all duration-500"
            [style.width.%]="warehouse.temperature_stability">
          </div>
        </div>

        <!-- Stats -->
        <div class="text-sm text-gray-600 space-y-1">

          <div>
            Total Readings:
            <span class="font-medium">
              {{ warehouse.summary?.total_readings }}
            </span>
          </div>

          <div class="text-green-600">
            Stable:
            <span class="font-medium">
              {{ warehouse.summary?.stable_temperature_readings }}
            </span>
          </div>

          <div class="text-red-500">
            Out of Range:
            <span class="font-medium">
              {{ warehouse.summary?.out_of_range_temperature_readings }}
            </span>
          </div>

        </div>

      </div>

    </div>

  </div>

  <!-- ================= TABLE TAB ================= -->
  <div *ngIf="activeTab === 'table'">

    <app-paginated-data-table
      [tableList]="tableData"
      [resetTable]="refreshDataTable"
      [tableConfigurations]="tableConfiguration">
    </app-paginated-data-table>

  </div>

</div>

<!-- Empty -->
<div *ngIf="!loading && tableData.length === 0"
     class="p-6 text-center text-gray-500">
  No temperature stability data available.
</div>